import React, { useEffect, useState } from "react";
import { Box, Grid, CssBaseline } from "@mui/material";
import LOGO from "./../../assets/LoginLogo.png";

import { useLocation } from "react-router-dom";
import Message from "./Message";
import Intro from "./Intro";
import SignUpPage from "./SignUpPage";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles({
  background: {
    backgroundImage: `url(${require("../../assets/lockScreen.jpg")})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    position: "relative",
    filter: "brightness(100%)",
  },
  rightSide: {
    display: "flex",
    flexDirection: "column !important",
    alignItems: "center ",
    justifyContent: "start",
  },
  formContainer: {
    marginTop: "10%",
    maxWidth: "400px",
    padding: "32px !important",
    borderRadius: 3,
    backgroundColor: "white",
  },
  logoContainer: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "32px !important",
  },
});

const LeadsGeneration = () => {
  const [page, setPage] = useState(1);
  const [message, setMessage] = useState(false);

  const location = useLocation();
  const { contactDetails, userSignUpStatus } = location.state || {};
  const [phoneNumber, setPhoneNumber] = useState();
  const classes = useStyles();
  useEffect(() => {
    if (contactDetails && contactDetails.mobileNumber) {
      setPhoneNumber(contactDetails.mobileNumber);
    }
  }, [contactDetails]);

  useEffect(() => {
    if (userSignUpStatus === "completed") {
      setMessage(true);
    }
  }, [userSignUpStatus]);

  return (
    <Grid
      container
      component="main"
      sx={{
        height: "100vh",
      }}
    >
      <CssBaseline />

      <Grid
        item
        xs={false}
        sm={4}
        md={8}
        sx={{
          backgroundColor: (t) =>
            t.palette.mode === "light"
              ? t.palette.grey[50]
              : t.palette.grey[900],
        }}
        className={classes.background}
      />

      <Grid
        item
        xs={12}
        sm={8}
        md={4}
        component={Box}
        className={classes.rightSide}
      >
        <Box className={classes.formContainer}>
          <Box className={classes.logoContainer}>
            <img
              src={LOGO}
              alt="Logo"
              style={{ width: "45%", objectFit: "contain" }}
            />
          </Box>

          {message && <Message />}

          {page === 1 && !message && <Intro setPage={setPage} />}

          {page === 2 && !message && (
            <SignUpPage
              setPage={setPage}
              phoneNumber={phoneNumber}
              setMessage={setMessage}
            />
          )}
        </Box>
      </Grid>
    </Grid>
  );
};
export default LeadsGeneration;
